import React from 'react';
import { useAlarms } from '../useAlarms';
import { StyledAlarmLamp } from './styles';
import { Alarm } from '../../../../types/orders/Alarms';

type AlarmLampProps = {
    alarm: Alarm;
};

export const AlarmLamp: React.FC<AlarmLampProps> = ({ alarm }) => {
    const { color, setAlarmColor, isFlashing } = useAlarms({
        alarm: alarm,
    });

    React.useEffect(() => {
        setAlarmColor();
    }, [alarm]);

    return <StyledAlarmLamp color={color} is_flashing={isFlashing.toString()} />;
};
